import React from 'react';
import Card from '../../common/card/Card';
import AppCarousel from '../../common/appCarousel/AppCarousel';

import drippingFaucetImg from '../../assets/DrippingFaucet.png';
import img1 from '../../assets/johnny-mcclung-uDM99xirqI4-unsplash.jpg';
import img2 from '../../assets/aaron-burden-Kp9z6zcUfGw-unsplash.jpg';
import img3 from '../../assets/cesar-couto-eIDXdlfelVE-unsplash.jpg';

const QuickTipContainer = ({ children }) => <div>{children}</div>;
const QuickTipImage = (props) => (
  <img
    className="w-full"
    style={{ objectFit: 'cover', objectPosition: 'bottom', height: '250px' }}
    {...props}
    alt='Quick Tip Topic'
  ></img>
);

const QuickTips = ({ ...rest }) => {
  return (
    <Card
      title="Quick Tip"
      bodyClassName="flex-col pl-0 pr-0 pt-0"
      {...rest}
      serviceRequestColor
    >
      <AppCarousel
        data={[
          <QuickTipContainer>
            <QuickTipImage src={drippingFaucetImg} alt="Dripping Faucet" />
            <p className="mt-6 w-4/5 m-auto leading-loose">
              <span className="font-bold">Turn Off Faucets: </span>
              Bathroom faucets run at about 2 gallons of water a minute. Turn
              off the tap while you brush your teeth and you can save hundreds
              of gallons a month
            </p>
          </QuickTipContainer>,

          <QuickTipContainer>
            <QuickTipImage src={img1} alt="Girl Drinking Water" />
            <p className="mt-6 w-4/5 m-auto leading-loose">
              <span className="font-bold">Drink more: </span>
              You could survive about a month without food, but you could only
              survive 5 or 6 days without water.
            </p>
          </QuickTipContainer>,
          <QuickTipContainer>
            <QuickTipImage src={img2} alt="Water On Leaf" />
            <p className="mt-6 w-4/5 m-auto leading-loose">
              <span className="font-bold">The water molecule: </span>A water
              molecule stays in the ocean for 98 years, in ice for 20 months, in
              lakes and rivers for 2 weeks, and in the atmosphere for less than
              7 days.
            </p>
          </QuickTipContainer>,
          <QuickTipContainer>
            <QuickTipImage src={img3} alt="Water Drop" />
            <p className="mt-6 w-4/5 m-auto leading-loose">
              <span className="font-bold">Water conservation: </span>If the
              world's water supply were only 100 liters (26 gallons), our usable
              water supply of fresh water would be only about 0.003 liter
              (one-half teaspoon).
            </p>
          </QuickTipContainer>,
        ]}
      />
    </Card>
  );
};

export default QuickTips;
